export default {"src":"/_next/static/media/serial-prompt.fd15e183.gif","height":600,"width":937,"blurWidth":0,"blurHeight":0};